import styled from "styled-components";
import { useRef, useEffect } from "react";
import anime from "animejs";
import { useInView } from 'react-intersection-observer';
import { mq } from "../util/media";

import Button from "../Button";
import LearnMoreButton from "../LearnMoreButton";
import GradientText from "../GradientText";
import SectionWrapper from "../SectionWrapper";
import SectionTitle from "../SectionTitle";

import {ReactComponent as Graph} from "../../images/graph.svg";

const MainText = styled.p`
  font-size: 20px;
  line-height: 1.4;
  letter-spacing: 0.5px;

  margin: 0;
  margin-bottom: 24px;

  ${mq.lt.md} {
    font-size: 15px;
  }

  ${mq.lt.sm} {
    text-align: center;
    font-size: 11px;
    max-width: 265px;
    margin-left: auto;
    margin-right: auto;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;

  justify-content: center;


  ${mq.gt.xs} {
    gap: 2rem;
    justify-content: flex-start;
  }
`

const ImageContainer = styled.div`
  display:flex ;
  ${mq.lt.sm} {

    margin-left: -24px;
    margin-right: -24px;

    svg {
      margin: 0 auto;

    }

    svg .svg_graph-line {
      stroke-width: 10px;
    }
  }

  svg path:nth-child(1) {
    transform-origin: center bottom;
    transform: scaleY(0);
  }

  svg path:nth-child(2) {
    stroke-dashoffset: 1939px;
  }

  &.hidden {
    opacity: 0;
  }

  & .flash {
    transition: linear 0.2s;
    filter: drop-shadow(0px 0px 200px pink);
  }

`

const InfoWrapper = styled.div`
  margin: 5rem 0 4rem 0;
  ${mq.lt.md} {
    margin: 45px 0;
  }

  transition: 0.7s ease-in-out;
  &.hidden {
    opacity: 0;
    transform: translateY(10%);
  }
`

const Inner = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 2rem;
  width: 100%;
`

const GraphStyle = styled(Graph)`
  transform-origin: bottom center;
  max-width: 100%;

`

function FrictionlessAccess() {

  const graphImageRef = useRef(null);
  const [graphViewRef, graphInView] = useInView({
    triggerOnce: true,
    threshold: 0.6
  });

  if(graphImageRef.current) {
    var graphAnimeTimeline = anime.timeline({
      easing: 'easeOutExpo',
      loop: false,
      autoplay: false,
      direction: 'normal'
    });
  
    graphAnimeTimeline.add({
      targets: graphImageRef.current.children[0],
      delay: 200,
      scaleY: [0, 1],
      duration: 1000,
    })
    .add({
      targets: graphImageRef.current.children[1],
      easing: 'easeInQuad',
      strokeDashoffset: [anime.setDashoffset, 0],
      duration: 4000,
    }, '-=1000')
  }

  useEffect(() => {
    if (graphInView) {
      graphAnimeTimeline.play()
    }
  }, [graphAnimeTimeline, graphInView]);

  const [textRef, textInView] = useInView({
    triggerOnce: true,
    threshold: 0.6
  });


  return(
    <SectionWrapper smaller>

        <Inner>

          <InfoWrapper ref={textRef} className={textInView ? "" : "hidden" }>
            <SectionTitle>Near Treasury offers <br /><GradientText to="right" color1="#D26BDC" color2="#EF9876">frictionless access</GradientText></SectionTitle>
            <MainText>
              Earn 23.97% APY in just three simple steps. <br />Start your savings journey now and grow your portfolio today.
            </MainText>

            <ButtonContainer>
              <LearnMoreButton>Learn More</LearnMoreButton>
              <Button link="/webapp" type="save">Save Now</Button>
            </ButtonContainer>
          </InfoWrapper>

          <ImageContainer ref={graphViewRef} className={graphInView ? "" : "hidden" }>
            <GraphStyle ref={graphImageRef} />
          </ImageContainer>
          

          
        </Inner>

    </SectionWrapper>

  )
}

export default FrictionlessAccess;